const noscrollOffset = (el) => {
  const vw = window.innerWidth;
  let yOffset;
  if (vw <= 560) {
    yOffset = -88;
  } else if (vw <= 800) {
    yOffset = -112;
  } else if (vw <= 1024) {
    yOffset = -104;
  } else if (vw <= 1440) {
    yOffset = -136;
  } else {
    yOffset = -144;
  }

  const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
  window.scrollTo({ top: y });
};
export default noscrollOffset;
